module.exports = __webpack_public_path__ + "img/private_seal.5f87347e.png";